import { Calendar, CalendarBlank } from "@phosphor-icons/react";
import { phaseRegistry } from "../registry.js";
import { PhaseTile } from "../components.js";
import { PostTable } from "../table.js";
import {
  EmptyState,
  EmptyStateIcon,
  EmptyStateTitle,
} from "@/components/ui/empty-state";

const ScheduledPage = () => {
  return (
    <PostTable
      search="phase:scheduling"
      emptyState={
        <EmptyState>
          <EmptyStateIcon>
            <CalendarBlank />
          </EmptyStateIcon>
          <EmptyStateTitle>No posts to schedule.</EmptyStateTitle>
        </EmptyState>
      }
    />
  );
};

const ScheduledTile = () => {
  return (
    <PhaseTile phase="scheduling">
      <Calendar size={24} />
    </PhaseTile>
  );
};

phaseRegistry.register({
  type: "scheduling",
  order: 5,
  page: ScheduledPage,
  tile: ScheduledTile,
});
